import React from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import titleImage from "../../../assets/TitleUltimates.png";
import hitmanImage from "../../../assets/ultimates/hitman.png";
import panicRoomImage from "../../../assets/ultimates/panicroom.png";
import jammerImage from "../../../assets/ultimates/jammer.png";
import kleptoImage from "../../../assets/ultimates/klepto.png";
import pogMineImage from "../../../assets/ultimates/pogmine.png";
import godsPlanImage from "../../../assets/ultimates/godsplan.png";

const ultimates = [
  {
    name: "Hitman",
    image: hitmanImage,
    role: "Direct Pressure",
    description:
      "Lethal choice for students who feel decisive. Be the one who orchestrates and executes hits.",
  },
  {
    name: "Panic Room",
    image: panicRoomImage,
    role: "Emergency Defence",
    description:
      "A safety net for when the game turns nasty. Students with Panic Room refuse to be removed.",
  },
  {
    name: "Jammer",
    image: jammerImage,
    role: "Disruption Control",
    description:
      "All electronic, the Jammer counters, interferes, and shuts down pogforts electrical devices.",
  },
  {
    name: "Klepto",
    image: kleptoImage,
    role: "Resource Theft",
    description:
      "Klepto turns opportunity into profit pressuring resources; using five finger discounts.",
  },
  {
    name: "Pog Mine",
    image: pogMineImage,
    role: "Money Maker",
    description:
      "Generating wealth, these students become a valuable asset to both friends and opps alike.",
  },
  {
    name: "God's Plan",
    image: godsPlanImage,
    role: "Fate Breaker",
    description:
      "Healers of the world. God's Plan alters the outcome of wars with divine hands; healing stuff.",
  },
];

const Home = () => {
  const baseURL = window.location.origin;

  return (
    <div className="home-container ultimates-page">
      <Helmet>
        <title>Pogforts - Ultimates</title>
        <meta
          name="description"
          content="Choose your ultimate and shape the way you play Murder Mystery Magic at Pogforts."
        />
        <meta property="og:title" content="Pogforts Ultimates" />
        <meta
          property="og:description"
          content="Choose your ultimate and shape the way you play Murder Mystery Magic at Pogforts."
        />
        <meta property="og:image" content={`${baseURL}/PogfortsHome.png`} />
        <meta property="og:url" content={`${baseURL}/ultimates`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pogforts Ultimates" />
        <meta
          name="twitter:description"
          content="Choose your ultimate and shape the way you play Murder Mystery Magic at Pogforts."
        />
        <meta name="twitter:image" content={`${baseURL}/PogfortsHome.png`} />
      </Helmet>

      <h1 className="hidden-title">Pogforts Ultimates</h1>

      <img
        src={titleImage}
        alt="Pogforts Ultimates"
        className="featured-image ultimates-title-image"
      />

      <section className="ultimates-shell panel-shell">
        <div className="ultimates-panel panel-surface panel-surface-tall">
          <div className="ultimates-topbar panel-topbar">
            <div>
              <div className="panel-kicker">POGFORTS LOADOUT</div>
              <h2 className="panel-title">Ultimates</h2>
              <p className="panel-subtitle">
                Your ultimate is your signature move inside Murder Mystery Magic.
              </p>
            </div>
          </div>

          <section className="ultimates-section ultimates-section-overview">
            <div className="ultimates-section-header">
              <div className="ultimates-section-kicker">OVERVIEW</div>
              <h3 className="ultimates-section-title">Choose Your Endgame</h3>
            </div>

            <div className="ultimates-intro-card">
              <p>
                Selecting your ultimate changes the way you play the game. It defines your endgame move, shapes how you threaten, defend, deceive, or recover, and gives every student a different path through Murder Mystery Magic.
              </p>
              <p>
                Choose carefully: an ultimate is not just an attack button. It is a playstyle, a warning, and a final card that can alter the pressure of an entire cycle.
              </p>
            </div>
          </section>

          <section className="ultimates-section ultimates-section-catalogue">
            <div className="ultimates-section-header">
              <div className="ultimates-section-kicker">CATALOGUE</div>
              <h3 className="ultimates-section-title">Available Ultimates</h3>
              <p className="ultimates-section-text">
                Each ultimate creates a different strategic identity. Some protect, some punish, some steal, and some rewrite the end of the fight.
              </p>
            </div>

            <div className="ultimates-list">
              {ultimates.map((ultimate) => (
                <article className="ultimates-row" key={ultimate.name}>
                  <div className="ultimates-image-frame">
                    <img
                      src={ultimate.image}
                      alt={`${ultimate.name} ultimate icon`}
                      className="ultimates-image"
                    />
                  </div>

                  <div className="ultimates-copy">
                    <div className="ultimates-name">{ultimate.name}</div>
                    <div className="ultimates-role">{ultimate.role}</div>
                    <p>{ultimate.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Home;
